// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__32adZ","tab":"Tabs_tab__1-8aG","tabActive":"Tabs_tabActive__fPmbY"};